import React from "react";
import Form from "../forms/form";

import MyCountdown from "../parts/countdown";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import FormatsDecor from "../../img/decor/format_decor.png";
import FormatsDecor_2 from "../../img/decor/format_decor_2.png";
import GetLogo from "../../img/get_logo.svg";


const formats = [
    {
        id: "standard",
        title: "STANDARD",
        price: "1000",
        oldPrice: "2500",
        bg: "bg-[#EEEEFF]",
        textColor: "text-black",
        cardBg: "bg-white",
        cutoutColor: "#EEEEFF",
        image: FormatsDecor,
        features: [
            "Відвідування GET Business Festival офлайн",
            "Доступ до всіх сцен",
            "Можливість поставити запитання спікерам",
            "Нетворкінг з учасниками фестивалю",
            "Кава-брейки",
            "Виставкова зона",
            "Презентації спікерів GET",
            "Запис трансляції всіх сцен фестивалю",
            "Фотозвіт з фестивалю",
        ],
    },
    {
        id: "vip",
        title: "VIP VIP VIP",
        price: "3000",
        oldPrice: "5000",
        bg: "bg-[#00007C]",
        textColor: "text-white",
        cardBg: "bg-[#EEEEFF]",
        cutoutColor: "#00007C",
        image: FormatsDecor,
        features: [
            "Відвідування GET Business Festival офлайн",
            "Доступ до всіх сцен",
            "Можливість поставити запитання спікерам",
            "Нетворкінг з учасниками фестивалю",
            "Кава-брейки",
            "Виставкова зона",
            "Презентації спікерів GET",
            "Запис трансляції всіх сцен фестивалю",
            "Фотозвіт з фестивалю",
            "Окрема стійка реєстрації",
            "Нетворкінг зі спікерами",
            "Бізнес-бранч"
        ],
    },
];


const Formats = () => {
    return (
        <section
            id="formats"
            className="bg-[#EEEEFF] pt-[60px] lg:pt-[120px]"
        >
            <div className="container mx-auto max-w-full px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]">
                <h2 className="mb-[25px] text-[clamp(34px,calc(34px+53*((100vw-390px)/1530)),87px)] font-black uppercase leading-[1.2] text-[#26265d] xl:mb-[40px]">
                    Формати участі
                </h2>

                <p className="text-[16px] leading-[1.2] text-[#292967] md:text-[18px]">
                    Оберіть зручний формат участі
                </p>
            </div>

            <div className="mt-[35px] lg:mt-[60px]">
                {formats.map((format) => (
                    <div
                        key={format.id}
                        className={`${format.bg} ${format.textColor}`}
                    >
                        <div className="mx-auto max-w-full px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)] py-[clamp(25px,4vw,60px)]">

                            {/* БИЛЕТ */}
                            <div
                                className={`relative overflow-hidden shadow-[0_0_10px_rgba(0,0,0,0.15)] ${format.cardBg}`}
                            >
                                <div className="grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_minmax(0,0.85fr)]">

                                    {/* ЛЕВАЯ ЧАСТЬ */}
                                    <div className="relative flex min-h-[230px] flex-col justify-between overflow-hidden px-[22px] pt-[24px] pb-[12px] sm:min-h-[300px] sm:px-[35px] md:min-h-[340px] md:px-[clamp(25px,3vw,55px)] md:pt-[35px] md:pb-[20px] xl:min-h-[400px]">

                                        {/* Декоративный фон */}
                                        <img
                                            src={format.image}
                                            alt=""
                                            className="absolute inset-0 w-full object-cover"
                                        />

                                        {/* Логотип */}
                                        <img
                                            src={GetLogo}
                                            alt="GET Business Festival"
                                            className="absolute top-1/2 left-[40px] -translate-y-1/2 z-10 w-[140px] object-contain sm:w-[180px] md:w-[clamp(150px,15vw,245px)]"
                                        />

                                        {/* Название тарифа */}
                                        <h3
                                            className={`
                                                absolute
                                        bottom-0
                                        left-1/2
                                        -translate-x-1/2
                                        md:text-[clamp(32px,6vw,120px)]
                                                 z-10  w-fit max-w-full text-[clamp(42px,6vw,90px)] font-black uppercase leading-[0.9] 
                                                 tracking-tight text-nowrap ${format.id === "vip"
                                                    ? "text-white"
                                                    : "bg-[linear-gradient(110deg,#C8F4F0_0%,#A8BFFF_18%,#D7A7F5_32%,#F1D9EA_42%,#BDEFF2_52%,#8EB8F4_66%,#8589F1_82%,#7774E8_100%)] bg-clip-text text-transparent"
                                                }`}
                                        >
                                            {format.title}
                                        </h3>
                                    </div>

                                    {/* ПРАВАЯ ЧАСТЬ */}
                                    <div className={`relative flex min-w-0 flex-col justify-between ${format.id === "standard" ? "bg-white" : "bg-[#EEEEFF]"
                                        } px-[22px] py-[25px] sm:px-[35px] md:px-[clamp(20px,3vw,55px)] md:py-[35px]`}>
                                        {/* Список преимуществ */}
                                        <ul className="grid gap-[9px] md:gap-[12px]">
                                            {format.features.map(
                                                (feature, index) => (
                                                    <li
                                                        key={index}
                                                        className="relative pl-[18px] text-[14px] leading-[1.35] text-[#26265D] before:absolute before:left-0 before:top-[0.55em] before:size-[5px] before:rounded-full before:bg-[#26265D] sm:text-[16px] xl:text-[18px]"
                                                    >
                                                        {feature}
                                                    </li>
                                                )
                                            )}
                                        </ul>

                                    </div>
                                </div>

                                {/* ЛИНИЯ ОТРЫВА — DESKTOP */}
                                <div className="pointer-events-none absolute bottom-0 left-[54.05%] top-0 z-20 hidden md:block">
                                    <div
                                        className="absolute bottom-[15px] top-[15px] w-px"
                                        style={{
                                            backgroundImage:
                                                "repeating-linear-gradient(to bottom, #7777A7 0 5px, transparent 5px 10px)",
                                        }}
                                    />

                                    <span
                                        className="absolute -left-[15px] -top-[15px] size-[30px] rounded-full"
                                        style={{
                                            backgroundColor: format.cutoutColor,
                                        }}
                                    />

                                    <span
                                        className="absolute -bottom-[15px] -left-[15px] size-[30px] rounded-full"
                                        style={{
                                            backgroundColor: format.cutoutColor,
                                        }}
                                    />
                                </div>

                                {/* ЛИНИЯ ОТРЫВА — MOBILE */}
                                <div className="pointer-events-none absolute left-0 right-0 top-[230px] z-20 sm:top-[300px] md:hidden">
                                    <div
                                        className="absolute left-[15px] right-[15px] top-0 h-px"
                                        style={{
                                            backgroundImage:
                                                "repeating-linear-gradient(to right, #7777A7 0 5px, transparent 5px 10px)",
                                        }}
                                    />

                                    <span
                                        className="absolute -left-[15px] -top-[15px] size-[30px] rounded-full"
                                        style={{
                                            backgroundColor: format.cutoutColor,
                                        }}
                                    />

                                    <span
                                        className="absolute -right-[15px] -top-[15px] size-[30px] rounded-full"
                                        style={{
                                            backgroundColor: format.cutoutColor,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Formats;